const state= {
    Items:{
      data:[],
      total:0,
      pages: {
          page:1,
          totalPage : 1,
          limit:25,
          filter:{}
      },
    },
    Item: null,
    clientcontracts : {
      data        : [],
      paginator   : 1,
      currentPage : 1,
      limit       : 25,
      total       : 0,
      filter: null
    },
    relatedSupplier: {
      data: [],
      total: 0,
      contract_id: 0
    },
    contract : {},
    s_contract : {},
    contractTermSelect: null,
    Loadings:{
      list: true,
      create: true,
      detail: false
    },
    supplierContracts : {
      data        : [],
      paginator   : 1,
      currentPage : 1,
      limit       : 25,
      total       : 0,
      filter      : null
    },
    contract_dropdown: {
      data        : [],
      total       : 0,
    }
};

const getters = {
    ListClientContract : (state) => state.clientcontracts,
    ClientContractID : (state) => state.contract,
    SContract : (state) => state.s_contract,
    ContractTermSelect : (state) => state.contractTermSelect,
    Loadings : (state) => state.Loadings,
    ListSupplierContract : (state) => state.supplierContracts,
    relatedSupplier : (state) => state.relatedSupplier,
    contractDropdown : (state) => state.contract_dropdown,
    ItemContracts : (state) => state.Items,
};

const actions = {
  async getRelatedSupplier({commit}, params){
    commit( 'setLoadings', {key:"list",val:true});
    return new Promise (( resolve, reject ) => {
        global.axios(`/api/contracts/${params.contract_id}/related-supplier`, {
          method: "GET",
          params: { contract_id: params.contract_id, contract_type: params.contract_type },
          headers: {
            Accept: "application/json",
          },
        })
        .then(response => {
          commit('setRelatedSupplier', { data: response.data.data, contract_id: params.contract_id } );
          commit( 'setLoadings', {key:"list",val:false});
          resolve( response );
        })
        .catch(error => reject( error ));
    });
  },
  async getList({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setLoadings', {key:"list",val:true});
      global.axios(`api/contracts`, {
        method: "GET",
        data:  {},
        params: params,
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
        commit( 'setLoadings', {key:"list",val:false});
        response.data.data.pages = params
        commit( 'setListItems', response.data.data );
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async getListclientcontracts({commit}, params){
    return new Promise (( resolve, reject ) => {
      let page    = params[0];
      let filters = params[1];
      let limit   = params[2];
      let isCMS   = params[3];
      commit( 'setLoadings', {key:"list",val:true});
      global.axios(`api/contracts`, {
        method: "GET",
        data:  {},
        params: {
            isCMS  : isCMS || '',
            limit  : limit || 50,
            page   : page || 1,
            filter : filters
        },
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
        if(response.data.status == 200) {
          let param = {
            contracts: response.data.data.contracts,
            total: response.data.data.total,
            currentPage: page,
            limit: limit || 50,
            filter: filters
          }
          commit( 'setListclientContract', param );
        }
        commit( 'setLoadings', {key:"list",val:false});
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async getListClientContractsSearch({commit}, params){
    return new Promise (( resolve, reject ) => {
      let page    = params[0];
      let filters = params[1];
      let limit   = params[2];
      let isCMS   = params[3];

      global.axios(`api/contracts`, {
        method: "GET",
        data:  {},
        params: {
          isCMS  : isCMS || '',
          limit  : limit || 50,
          page   : page || 1,
          filter : filters
        },
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        if(response.data.status == 200) {
          let param = {
            data: response.data.data.contracts,
            paginator   : Math.ceil(response.data.data.total / limit),
            total: response.data.data.total,
            currentPage: page,
            limit: limit || 50,
            filter: filters
          }
          commit( 'setContractDropdown', param);
          resolve( param );
        }
      })
      .catch(error => reject( error ));
    });
  },
  async getListClientContractsSearchAll({commit}, params){
    return new Promise (( resolve, reject ) => {
      let page    = params[0];
      let filters = params[1];
      let limit   = params[2];

      global.axios(`api/contracts`, {
        method: "GET",
        data:  {},
        params: {
          limit  : limit || 50,
          page   : page || 1,
          filter : filters
        },
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
          resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async getClientContractID({commit},params){
    return new Promise (( resolve, reject ) => {
      global.axios(`/api/contracts/`+ params , {
          method: "GET",
          headers: {
              Accept: "application/json",
          }
      })
      .then(response => {
        commit('setClientContractID', response.data.data)
        commit('setContractTermSelect', response.data.data.contract_terms[0])
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async getClientContract({commit},params){
    return new Promise (( resolve, reject ) => {
      global.axios(`/api/contracts/`+ params , {
          method: "GET",
          headers: {
              Accept: "application/json",
          }
      })
      .then(response => {
        commit('setClientContractID', response.data.data)
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async getSContract({commit},params){
    return new Promise (( resolve, reject ) => {
      global.axios(`/api/contracts/`+ params , {
          method: "GET",
          headers: {
              Accept: "application/json",
          }
      })
      .then(response => {
        commit('setSContract', response.data.data)
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async CreateClientContract({commit},params){
    return new Promise (( resolve, reject ) => {
      global.axios(`/api/contracts`, {
          method: "POST",
          data: params,
          headers: {
              Accept: "application/json",
          }
      })
      .then(response => {
          if(response.data.status == 200 && response.data.data.code != 400) {
              commit('updateListClientContract', response.data.data)
          }
          resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async UpdateClientContract({commit},params){
    return new Promise (( resolve, reject ) => {
      global.axios(`/api/contracts/` + params.contract_id, {
        method: "PUT",
        data: params,
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
        if(!response.data.data.code) {
          commit('editListClientContract',response.data.data.data);
        }
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async deleteClientContract({commit},params){
      return new Promise (( resolve, reject ) => {
          global.axios(`/api/contracts`, {
              method: "DELETE",
              headers: {
                Accept: "application/json",
              },
              data : {
                ids : params
              }
          })
          .then(response => {
            commit( 'deleteClientContract', params);
            resolve( response );
          })
          .catch(error => reject( error ));
      });
  },
  async getListSContracts({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setLoadings', {key:"list",val:true});
      global.axios(`api/s-contracts`, {
        method: "GET",
        data:  {},
        params: params,
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
        commit( 'setLoadings', {key:"list",val:false});
        response.data.data.pages = params
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async getListSupplierContracts({commit}, params){
    return new Promise (( resolve, reject ) => {
      let page    = params[0];
      var filters = params[1];
      let limit   = params[2];
      let isCMS   = params[3];
      commit( 'setLoadings', {key:"list",val:true});
      global.axios(`api/s-contracts`, {
        method: "GET",
        data:  {},
        params: {
            isCMS  : isCMS || '',
            limit  : limit || 50,
            page   : page || 1,
            filter : filters
        },
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
        if(response.data.status == 200) {
          let data = {
            contracts: response.data.data.contracts,
            total: response.data.data.total,
            currentPage: page,
            limit: limit || 50,
            filter: filters
          }
          commit( 'setListSupplierContract', data );
        }
        commit( 'setLoadings', {key:"list",val:false});
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async CreateSupplierContract({commit},params){
    return new Promise (( resolve, reject ) => {
      global.axios(`/api/s-contracts`, {
          method: "POST",
          data: params,
          headers: {
              Accept: "application/json",
          }
      })
      .then(response => {
          if(response.data.status == 200) {
            commit('updateListSupplierContract', response.data.data)
          }
          resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async UpdateSupllierContract({commit},params){
    return new Promise (( resolve, reject ) => {
      global.axios(`/api/s-contracts/` + params.contract_id, {
        method: "PUT",
        data: params,
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
        commit('editListSupplierContract', response.data.data.data)
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async deleteSupplierContract({commit},params){
    return new Promise (( resolve, reject ) => {
        global.axios(`/api/s-contracts`, {
            method: "DELETE",
            headers: {
              Accept: "application/json",
            },
            data : {
                ids : params
            }
        })
        .then(response => {
            resolve( response );
        })
        .catch(error => reject( error ));
    });
  },
  async uploadAttachment({commit,state},params){
    return new Promise (( resolve, reject ) => {
      let formData = new FormData();
      formData.append('attachment', params.attachment);
      formData.append('attachment_type', params.attachmentType);
      formData.append('attachment_title', params.attachmentTitle || '');
      global.axios(`/api/contracts/attachments/${params.contract_id}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          data : formData
      })
      .then(response => {
         //commit('setClientContractID',{...state.contract,...response.data.data})
         resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async removeAttachments({commit},params){
    return new Promise (( resolve, reject ) => {
      global.axios(`/api/attachments`, {
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
          data : params
      })
      .then(response => {
         resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async updateAttachments({commit,state},params){
    return new Promise (( resolve, reject ) => {
      let formData = new FormData();
      if(params.attachment)
        formData.append('attachment', params.attachment);
      formData.append('attachment_type', params.attachmentType);
      formData.append('attachment_title', params.attachmentTitle || '');
      formData.append('attachment_id', params.attachment_id );
      global.axios(`api/contracts/attachments/${params.contract_id}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          data : formData
      })
      .then(response => {
        //commit('setClientContractID',{...state.contract,...response.data.data})
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async updateVendorLinking({commit},params){
    return new Promise (( resolve, reject ) => {
      global.axios(`/api/vendor-linkings/generate`, {
        method: "POST",
        data: params,
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async updateStatusContract({commit},params){
    return new Promise (( resolve, reject ) => {
      global.axios(`/api/contracts/${params.contract_id}/status`, {
        method: "PUT",
        data: {
          status: params.status
        },
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        commit('editListClientContract',state.contract);
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async updateStatusScontract({ commit }, params) {
    return new Promise((resolve, reject) => {
      global.axios(`/api/contracts/${params.contract_id}/status`, {
        method: "PUT",
        data: {
          status: params.status
        },
        headers: {
          Accept: "application/json",
        }
      })
        .then(response => {
          commit('editListSupplierContract', state.contract);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  async getNLTContract({commit}){
    return new Promise (( resolve, reject ) => {
      commit( 'setLoadings', {key:"list",val:true});
      global.axios(`api/contracts/nlt-contracts`, {
        method: "GET",
        data:  {},
        headers: {
          Accept: "application/json",
        }
      })
        .then(response => {
          resolve( response.data.data );
        })
        .catch(error => reject( error ));
    });
  },
};

const mutations = {
    setListItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit )
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setListclientContract (state,contracts) {
      state.clientcontracts = {
        data        : contracts.contracts,
        paginator   : Math.ceil(contracts.total / contracts.limit),
        currentPage : contracts.currentPage,
        limit       : contracts.limit,
        total       : contracts.total,
        filter      : contracts.filter
      };
    },
    setContractDropdown (state,data) {
      state.contract_dropdown.data = data.data
      state.contract_dropdown.total = data.total
    },
    updateListClientContract (state, data) {
      if(state.clientcontracts.data) {
        if(state.clientcontracts.data.length == state.clientcontracts.limit) {
          state.clientcontracts.data.splice((state.clientcontracts.data.length - 1), 1)
        }
        state.clientcontracts.data.unshift(data)
        state.clientcontracts.total += 1
        state.clientcontracts.paginator = Math.ceil(state.clientcontracts.total / state.clientcontracts.limit)
      }
    },
    setClientContractID (state, contract) {
      state.contract = contract
      if(contract && contract.contract_terms && contract.contract_terms.length > 0){
        state.contractTermSelect = contract.contract_terms[0]
      }
    },
    setSContract (state, contract) {
      state.s_contract = contract
      if(contract && contract.contract_terms && contract.contract_terms.length > 0){
        state.contractTermSelect = contract.contract_terms[0]
      }
    },
    setContractTermSelect(state, term) {
        state.contractTermSelect = term
    },
    setRelatedSupplier(state, data) {
      state.relatedSupplier.data = data.data.listSuppler
      state.relatedSupplier.total = data.data.total
      state.relatedSupplier.contract_id = data.contract_id
    },
    setLoadings (state,data) {
        if(data.key === "list"){
          state.Loadings.list = data.val;
        }
        if(data.key === "create"){
          state.Loadings.list = data.val;
        }
    },
    setListSupplierContract (state,contracts) {
      state.supplierContracts = {
        data        : contracts.contracts,
        paginator   : Math.ceil(contracts.total / contracts.limit),
        currentPage : contracts.currentPage,
        limit       : contracts.limit,
        total       : contracts.total,
        filter      : contracts.filter
      };
    },
    updateListSupplierContract (state, data) {
      if(state.supplierContracts.data) {
        data.status = 'draft';
        state.supplierContracts.data.push(data)
      }
    },
    editListSupplierContract (state, data) {
      if(state.supplierContracts.data) {
        state.supplierContracts.data = state.supplierContracts.data.map(item => item.id === data.id ? data : item)
      }
    },
    editListClientContract (state, data) {
      if(state.clientcontracts.data) {
        state.clientcontracts.data = state.clientcontracts.data.map(item => item.id === data.id ? data : item)
      }
    },
    deleteClientContract (state, data) {
      if(state.clientcontracts.data) {
        state.clientcontracts.data = state.clientcontracts.data.filter(function(item) {
          return !data.some(function(id) {
                return item.id == id
          });
        });
      }
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
